import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { ProductGroupsDonutChart } from './ProductGroupsDonutChart';
import { ProductGroupsDonutLeaderLines } from './ProductGroupsDonutLeaderLines';
import { ProductGroupsLegendTable } from './ProductGroupsLegendTable';
import type { ProductGroupsChartData } from './report-product-groups.model';
import { useProductGroupsDonutRotation } from './use-product-groups-donut-rotation.hook';

type ProductGroupsDonutBlockProps = {
  data: ProductGroupsChartData;
};

/** Donut chart, leader lines and legend — shares drag rotation state. */
export const ProductGroupsDonutBlock: React.FC<
  ProductGroupsDonutBlockProps
> = ({ data }) => {
  const { classes } = useStyles();
  const rotation = useProductGroupsDonutRotation();

  return (
    <Box className={classes.root}>
      <ProductGroupsDonutChart
        data={data}
        rotationOffsetDeg={rotation.offsetDeg}
        isDragging={rotation.isDragging}
        slotRef={rotation.slotRef}
        onPointerDown={rotation.onPointerDown}
        onPointerMove={rotation.onPointerMove}
        onPointerUp={rotation.onPointerUp}
        onPointerCancel={rotation.onPointerCancel}
      />
      <ProductGroupsDonutLeaderLines
        segments={data.segments}
        rotationOffsetDeg={rotation.offsetDeg}
      />
      <ProductGroupsLegendTable segments={data.segments} />
    </Box>
  );
};

const useStyles = makeStyles()(() => ({
  root: {
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
  },
}));
